import { useAgGridDefaults } from "~/pages/UserAndRoles/utils/gridConfig";
import { useAgGridUtils } from "~/pages/UserAndRoles/utils/gridUtils";
import { RoleDetailsTable } from "../RoleDetailsTable";
import { usePermissionsTableAgGridOptions, useFetchPermissions } from "./hooks";
import type { useGetGroupsQuery } from "~/graphql/mainHooks";

type GroupsData = ReturnType<typeof useGetGroupsQuery>["data"];

type PermissionsTabProps = {
  title: string | undefined;
  groupsData?: GroupsData;
};

export const PermissionsTab = ({ title, groupsData }: PermissionsTabProps) => {
  const { columnDefs } = usePermissionsTableAgGridOptions();
  const { rowData, usePermissionsQueryResult } = useFetchPermissions(title, groupsData);
  const { gridOptions } = useAgGridDefaults({
    overrides: {
      statusBar: {
        statusPanels: [{ statusPanel: "agTotalRowCountComponent" }],
      },
      overlayNoRowsTemplate: "No permissions found",
    },
  });
  const { onGridReady, resetFilters, isFilterPresent, onFilterChanged } = useAgGridUtils();

  return (
    <RoleDetailsTable
      queryResult={usePermissionsQueryResult}
      title="Permissions"
      columnDefs={columnDefs}
      rowData={rowData}
      gridOptions={gridOptions}
      onGridReady={onGridReady}
      resetFilters={resetFilters}
      onFilterChanged={onFilterChanged}
      isFilterPresent={isFilterPresent}
    />
  );
};
